/**
 * /orgs/:orgId/automation — what runs in this organization without a client
 * asking (Feature 74, 3.1): the platform's linkages, each with its switch,
 * its warnings, and its record panel. One list since Feature 77 retired the
 * applied triggers beside them (D29); a `?tab=` an old address carries is
 * ignored. It takes Triggers' place in Configuration (Feature 74 D6).
 */
import { useRequiredOrgId } from '../../lib/use-current-org.js';
import { ListShape } from '../../ui/shapes.js';
import { TenantLinkages } from '../linkages/TenantLinkages.js';

export function OrgAutomationPage() {
  const orgId = useRequiredOrgId();
  return (
    <ListShape
      title="Automation"
      subtitle="What runs here without a client asking: the platform's linkages switched on."
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 22, paddingBottom: 64 }}>
        <TenantLinkages orgId={orgId} />
      </div>
    </ListShape>
  );
}
